import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import P from 'src/components/Dashboard/Views/P.vue'
import UserProfile from 'src/components/Dashboard/Views/UserProfile.vue'
import U from 'src/components/Dashboard/Views/U.vue'
import L from 'src/components/Dashboard/Views/L.vue'
import Icons from 'src/components/Dashboard/Views/Icons.vue'
import S from 'src/components/Dashboard/Views/S.vue'
import Rold from 'src/components/Dashboard/Views/R_old.vue'
import Reg from 'src/components/Dashboard/Views/Reg.vue'
import Profile from 'src/components/Dashboard/Views/Profile.vue'
import Location from 'src/components/Dashboard/Views/Location.vue'
import Subscription from 'src/components/Dashboard/Views/Subscription.vue'
import F from 'src/components/Dashboard/Views/F.vue'
import R1 from 'src/components/Dashboard/Views/R1.vue'
import Pp from 'src/components/Dashboard/Views/Pp.vue'
import Sw from 'src/components/Dashboard/Views/Sw.vue'
import Privacy from 'src/components/Dashboard/Views/Privacy.vue'
import Refund from 'src/components/Dashboard/Views/Refund.vue'
import Shipping from 'src/components/Dashboard/Views/Shipping.vue'
import Terms from 'src/components/Dashboard/Views/Terms.vue'
import Contact from 'src/components/Dashboard/Views/Contact.vue'
import G3school from 'src/components/Dashboard/Views/G3school.vue'
import PostpaidNotice from 'src/components/Dashboard/Views/PostpaidNotice.vue'
import Td from 'src/components/Dashboard/Views/Td.vue'
import ProductList from 'src/components/Dashboard/Views/ProductList.vue'
import EditSubscription from 'src/components/Dashboard/Views/EditSubscription.vue'
import SubscriptionVerification from 'src/components/Dashboard/Views/SubscriptionVerification.vue'
import Dispnewcust from 'src/components/Dashboard/Views/Dispnewcust.vue'
import Referral from 'src/components/Dashboard/Views/Referral.vue'
import Test from 'src/components/Dashboard/Views/Test.vue'
import Delfbdbfault from 'src/components/Dashboard/Views/Delfbdbfault.vue'
import Delfbloc from 'src/components/Dashboard/Views/Delfbloc.vue'
/* import Payments from 'src/components/Dashboard/Views/Payments.vue' */
import Notifications from 'src/components/Dashboard/Views/Notifications.vue'
import Tr1 from 'src/components/Dashboard/Views/Tr1.vue'
import UploadDailyMilkTestReport from 'src/components/Dashboard/Views/UploadDailyMilkTestReport.vue'
import Dmtr from 'src/components/Dashboard/Views/Dmtr.vue'
import AppLink from 'src/components/Dashboard/Views/AppLink.vue'
import MedcoAppLink from 'src/components/Dashboard/Views/MedcoAppLink.vue'
import Hmi from 'src/components/Dashboard/Views/Hmi.vue'
import Bill from 'src/components/Dashboard/Views/Bill.vue'
import UnsubPromo from 'src/components/Dashboard/Views/UnsubPromo.vue'

// routes added by rijul jain
import R from 'src/components/Dashboard/Views/R.vue'
import Referral2 from 'src/components/Dashboard/Views/Referral2.vue'
import FreeOrder from 'src/components/Dashboard/Views/Free_order.vue'

//priya
import PaytmContd from 'src/components/Dashboard/Views/PaytmContd.vue';
import Wc from 'src/components/Dashboard/Views/Wc.vue'

const routes = [
  {
    path: '/',
    // component: DashboardLayout,
    name: 'R',
    component: R,
    meta: {
      header: 1,
      footer: 1
    }
  },
  {
    path: '/a',
    component: DashboardLayout,
    // redirect: '/a/r',
    meta: {
      header: 1,
      footer: 1
    },
    children: [
      {
        path: 'p',
        name: 'P',
        component: P,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'u',
        name: 'U',
        component: U,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'uploadDailyMilkTestReport',
        name: 'UploadDailyMilkTestReport',
        component: UploadDailyMilkTestReport,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'Dmtr',
        name: 'Dmtr',
        component: Dmtr,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'hmi',
        name: 'Hmi',
        component: Hmi,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'bill',
        name: 'Bill',
        component: Bill,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'appLink',
        name: 'AppLink',
        component: AppLink,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'medcoAppLink',
        name: 'MedcoAppLink',
        component: MedcoAppLink,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'l',
        name: 'L',
        component: L,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'f',
        name: 'F',
        component: F,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'sw',
        name: 'Sw',
        component: Sw,
        meta: {
          header: 1,
          footer: 1
        }
      },
      /* {
        path: 'payment',
        name: 'Payment',
        component: Payments
      }, */
      {
        path: 's',
        name: 'S',
        component: S,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'r1',
        name: 'R1',
        component: R1,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'tr1',
        name: 'Tr1',
        component: Tr1,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'reg',
        name: 'Reg',
        component: Reg,
        meta: {
          header: 1,
          footer: 1
        }
      },
      // path added by rijul
      {
        path: 'rold',
        name: 'Rold',
        component: Rold,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'r',
        redirect: '/'
        /* name: 'R',
        component: R,
        meta: {
          header: 1,
          footer: 1
        } */
      },
      {
        path: 'referral2',
        name: 'Referral2',
        component: Referral2
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'location',
        name: 'Location',
        component: Location,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'subscription',
        name: 'Subscription',
        component: Subscription,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: Privacy,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'refund',
        name: 'Refund',
        component: Refund,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'shipping',
        name: 'Shipping',
        component: Shipping,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: Contact,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'terms',
        name: 'Terms',
        component: Terms,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'postpaidNotice',
        name: 'PostpaidNotice',
        component: PostpaidNotice,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'td',
        name: 'Td',
        component: Td,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'test',
        name: 'Test',
        component: Test,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'f1',
        name: 'Delfbloc',
        component: Delfbloc,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'f2',
        name: 'Delfbdbfault',
        component: Delfbdbfault,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'pp',
        name: 'Pp',
        component: Pp,
        meta: {
          header: 2,
          footer: 2
        }
      },
      {
        path: 'productList',
        name: 'ProductList',
        component: ProductList,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'editSubscription',
        name: 'EditSubscription',
        component: EditSubscription,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'subscriptionVerification',
        name: 'SubscriptionVerification',
        component: SubscriptionVerification,
        meta: {
          header: 1,
          footer: 2
        }
      },
      {
        path: 'dispnewcust',
        name: 'Dispnewcust',
        component: Dispnewcust,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'referral',
        name: 'Referral',
        component: Referral,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'unsubPromo',
        name: 'UnsubPromo',
        component: UnsubPromo,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'g3school',
        name: 'G3school',
        component: G3school,
        meta: {
          header: 2,
          footer: 2
        }
      }, /* ,
      {
        path: 'profile/:id',
        name: 'Profile',
        component: Profile
      } */
      {
        path: 'free_order',
        name: 'Free_order',
        component: FreeOrder,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'wc',
        name: 'Wc',
        component: Wc,
        meta: {
          header: 1,
          footer: 1
        }
      },
      {
        path: 'pc',
        name: 'PaytmContd',
        component: PaytmContd,
        meta: {
          header: 1,
          footer: 1
        }
      }
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js